import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState,
    fetchSingleRecord,
    addRecord,
    addRecordSuccess,
    addRecordFailure
} from './payment.action';
import { Payment } from './payment.model';

export interface PaymentRecordsState {
    singleData: Payment;
    loading: boolean;
    error: any;
}

export const initialState: PaymentRecordsState = {
    singleData: null,
    loading: false,
    error: null,
};


export const paymentRecordReducer = createReducer(

    initialState,

    // FETCH SINGLE RECORD
    on(fetchSingleRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null, loading: false };
    }),

    //ADD RECORD
    on(addRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(addRecordSuccess, (state) => {
        return { ...state, error: null, loading: false };
    }),
    on(addRecordFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);